export const RIPPLE_COLORS: { [key: string]: string} = {
    filled: 'rgba(255, 255, 255, .5)',
    'filled-tonal': 'rgba(255, 255, 255, .5)',
    outlined: 'rgba(255, 255, 255, .5)',
    text: 'rgba(255, 255, 255, .5)',
    invisible: 'transparent',
};
